window.casino = window.casino || {};
var repos = window.casino.repos = window.casino.repos || {};


repos.pokerSSOPLTurniriRepo = function () {
    var url = 'api/pokerssoplturniri';

    // radimo cache turnira, jednom je dosta
    var turniriPromise = null;

    var list = function () {
        if (!turniriPromise)
            turniriPromise = fetch(url)
            .then(casino.repos.base.checkResponse)
            .then(function (response) {
                return response.json();
            })
            .catch(casino.repos.base.handleNetworkException);

        return turniriPromise;
    };


    return {
        list: list
    }

}();